import { Icon } from '@components/primitives';
import colors from '@theme/colors';
import React from 'react';
import { TouchableOpacity, ViewStyle } from 'react-native';

export interface CheckboxProps {
  isChecked?: boolean;
  onChange?: (checked: boolean) => void;
  onPress?: () => void;
  disabled?: boolean;
  size?: number;
  color?: string;
  uncheckedColor?: string;
  testID?: string;
  style?: ViewStyle;
  // Additional props for compatibility
  alignSelf?: string;
  marginRight?: number | string;
  marginBottom?: number | string;
  marginTop?: number | string;
  marginLeft?: number | string;
  marginX?: number | string;
  marginY?: number | string;
  margin?: number | string;
  padding?: number | string;
  paddingX?: number | string;
  paddingY?: number | string;
  paddingTop?: number | string;
  paddingBottom?: number | string;
  paddingLeft?: number | string;
  paddingRight?: number | string;
  flex?: number;
  flexDirection?: string;
  alignItems?: string;
  justifyContent?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  isChecked = false,
  onChange,
  onPress,
  disabled = false,
  size = 24,
  color = colors.primary.carnation,
  uncheckedColor = colors.neutral.darkMist,
  testID,
  style,
  // Extract margin/padding props for style object
  alignSelf,
  marginRight,
  marginBottom,
  marginTop,
  marginLeft,
  marginX,
  marginY,
  margin,
  padding,
  paddingX,
  paddingY,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  flex,
  flexDirection,
  alignItems,
  justifyContent,
  ...otherProps
}) => {
  // Combine all style-related props into a single style object
  const combinedStyle: ViewStyle = {
    ...style,
    ...(alignSelf && { alignSelf }),
    ...(marginRight !== undefined && { marginRight }),
    ...(marginBottom !== undefined && { marginBottom }),
    ...(marginTop !== undefined && { marginTop }),
    ...(marginLeft !== undefined && { marginLeft }),
    ...(marginX !== undefined && { marginHorizontal: marginX }),
    ...(marginY !== undefined && { marginVertical: marginY }),
    ...(margin !== undefined && { margin }),
    ...(padding !== undefined && { padding }),
    ...(paddingX !== undefined && { paddingHorizontal: paddingX }),
    ...(paddingY !== undefined && { paddingVertical: paddingY }),
    ...(paddingTop !== undefined && { paddingTop }),
    ...(paddingBottom !== undefined && { paddingBottom }),
    ...(paddingLeft !== undefined && { paddingLeft }),
    ...(paddingRight !== undefined && { paddingRight }),
    ...(flex !== undefined && { flex }),
    ...(flexDirection && { flexDirection }),
    ...(alignItems && { alignItems }),
    ...(justifyContent && { justifyContent }),
  };

  const handlePress = () => {
    if (disabled) return;

    if (onChange) {
      onChange(!isChecked);
    }

    if (onPress) {
      onPress();
    }
  };

  return (
    <TouchableOpacity
      testID={testID}
      onPress={handlePress}
      disabled={disabled}
      style={[
        {
          width: size,
          height: size,
          borderRadius: 4,
          borderWidth: 2,
          borderColor: isChecked ? color : uncheckedColor,
          backgroundColor: isChecked ? color : colors.transparent,
          alignItems: 'center',
          justifyContent: 'center',
          opacity: disabled ? 0.5 : 1,
        },
        combinedStyle,
      ]}
      {...otherProps}>
      {isChecked && <Icon name="check" family="antdesign" size={size * 0.6} color="white" />}
    </TouchableOpacity>
  );
};

export default Checkbox;
